<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<a id="page01">
</a><a id="page02">
</a><a id="page03">
<h2 class="titlePageTitle">Paul Was Not a Christian</h2>
<p class="titlePageSubtitle">The Original Message of a Misunderstood Apostle</p>
<h2 class="titlePageAuthor">Pamela Eisenbaum</h2>
<p class="colophon"><img alt="image" src="Images/logo.jpg"/></p>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// paulwasnotachristian_tp01.vue?07108fcf